import * as React from "react";
import Form from "react-bootstrap/Form";

function myCustomTemplate(locals: Object) {
  return (
    <Form.Group
    // controlId="formPlaintextPassword"
    >
      <Form.Label style={{ fontSize: 14 }}>{locals.config.label}</Form.Label>

      <Form.Control
        // size="sm"
        type={locals.config.type === "password" ? "password" : "text"}
        placeholder={locals.config.placeholder}
        onChange={(value) => locals.onChange(value.target.value)}
        className={locals.hasError && "dangerClass"}
        value={locals.value}
        className="formcntrl"
        style={{ backgroundColor: "#d2d2d2", Color: "black" }}
      />

      {locals.hasError && (
        <p className="errormessage">{locals.config.errorMessage}</p>
      )}
    </Form.Group>
  );
}
export default myCustomTemplate;
